import { Injectable } from '@angular/core';
import {
  NodeModel,
  PagerModel,
  NodePagedModel,
  NodeExtendedWithRemoteAndPingLogModel
} from '../models';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ServiceHelpers } from 'src/app/shared/service.helpers';
import { GlobalConsts } from 'src/app/shared/global.vars';

@Injectable({
  providedIn: 'root'
})
export class NodeService {

  constructor(
    private httpClient: HttpClient,
    private serviceHelpers: ServiceHelpers
  ) { }

  claimNode(token: string): Observable<NodeModel> {
    return this.httpClient.post<NodeModel>(
      GlobalConsts.apiBaseUrl + 'Node/ClaimNode', { Token: token },
      this.serviceHelpers.getCommonHeaders());
  }
}
